import { LogLevel, getLogger } from '@ori/checkout-utils';

import { SubscriptionWizard } from '../SubscriptionWizard';
import { useSubscriptionTypes } from '../api/useSubscriptionTypes';
import { APP_NAME } from '../constants';
import { TypesProvider } from '../contexts';
import { StateContainer } from './StateContainer';

const logDebug = getLogger(APP_NAME, LogLevel.Debug);

export const SubscriptionContainer = ({ product }: { product?: string }) => {
  logDebug('SubscriptionContainer product:', product);
  const { data, error, isLoading } = useSubscriptionTypes(product);
  logDebug('SubscriptionContainer isLoading: ', isLoading, ' | data: ', data, ' | error: ', error);

  return (
    <TypesProvider value={{ types: data?.collection ?? [], isLoading }}>
      <StateContainer>
        <SubscriptionWizard />
      </StateContainer>
    </TypesProvider>
  );
};
